module.exports = __webpack_public_path__ + "assets/img/one-tab2-on.06906121.png";